import { useEffect, useState } from "react";

interface StatusMessageProps {
  status?: string | null;
}

export default function StatusMessage({ status }: StatusMessageProps) {
  const [animatedText, setAnimatedText] = useState("");

  useEffect(() => {
    if (!status) {
      // For empty status, just show the three dots animation
      setAnimatedText("");
      return;
    }

    // For actual status text, create the progressive dots animation
    let dotCount = 0;
    const interval = setInterval(() => {
      dotCount = (dotCount + 1) % 4; // Cycle through 0, 1, 2, 3 dots
      const dots = ".".repeat(dotCount);
      setAnimatedText(`${status}${dots}`);
    }, 500); // Change every 500ms

    return () => clearInterval(interval);
  }, [status]);

  return (
    <div className="flex justify-start items-start min-w-0">
      <img 
        src="/logo_blue_thumbnail.png" 
        alt="EnablAI Logo" 
        className="w-8 mr-0 mt-1 flex-shrink-0"
      />
      <div className="flex-1 bg-transparent text-gray-600 rounded-lg px-3 py-2 text-sm">
        <div className="flex items-center gap-2">
          {!status ? (
            // Show bouncing dots when no status text
            <div className="flex items-baseline space-x-1">
              <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce [animation-delay:-0.3s] mt-3"></div>
              <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce [animation-delay:-0.15s] mt-3"></div>
              <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce mt-3"></div>
            </div>
          ) : (
            // Show animated text with progressive dots
            <span className="italic">{animatedText}</span>
          )}
        </div>
      </div>
    </div>
  );
}